import { useState } from 'react';

interface CreateMarketorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (newMarketor: any) => void;
}

const CreateMarketorModal = ({ isOpen, onClose, onCreate }: CreateMarketorModalProps) => {
  const [newMarketor, setNewMarketor] = useState({
    twitch_user_id: '',
    twitch_display_name: '',
    email: '',
    name: '',
    refid: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewMarketor(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreate(newMarketor);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">Create New Marketor</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="twitch_user_id" className="block gothic-text-silver mb-1">Twitch User ID</label>
            <input
              id="twitch_user_id"
              name="twitch_user_id"
              type="text"
              value={newMarketor.twitch_user_id}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="twitch_display_name" className="block gothic-text-silver mb-1">Twitch Display Name</label>
            <input
              id="twitch_display_name"
              name="twitch_display_name"
              type="text"
              value={newMarketor.twitch_display_name}
              onChange={handleChange}
              className="gothic-input w-full"
            />
          </div>
          <div>
            <label htmlFor="email" className="block gothic-text-silver mb-1">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={newMarketor.email}
              onChange={handleChange}
              className="gothic-input w-full"
              required
            />
          </div>
          <div>
            <label htmlFor="name" className="block gothic-text-silver mb-1">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={newMarketor.name}
              onChange={handleChange}
              className="gothic-input w-full"
            />
          </div>
          <div>
            <label htmlFor="refid" className="block gothic-text-silver mb-1">Ref ID</label>
            <input
              id="refid"
              name="refid"
              type="text"
              value={newMarketor.refid}
              onChange={handleChange}
              className="gothic-input w-full"
            />
          </div>
          <div className="flex justify-end gap-4">
            <button type="button" onClick={onClose} className="gothic-button">Cancel</button>
            <button type="submit" className="gothic-button gothic-button-primary">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateMarketorModal;